export default {
  activityType: {
    RESTAURANT: "Restaurant",
    ATTRACTION: "Attraction",
    GENERIC_SERVICE: "Service",
  },
  cuisine: {
    italian: "Italian",
    spanish: "Spanish",
    canarian: "Canarian",
    mediterranean: "Mediterranean",
    japanese: "Japanese",
    chinese: "Chinese",
    thai: "Thai",
    indian: "Indian",
    mexican: "Mexican",
    american: "American",
    french: "French",
    greek: "Greek",
    middle_eastern: "Middle Eastern",
    seafood: "Seafood",
    steakhouse: "Steakhouse",
    vegetarian: "Vegetarian/Vegan",
    pizza: "Pizza",
    sushi: "Sushi",
    ramen: "Ramen",
    tapas: "Tapas",
    fast_food: "Fast Food",
    cafe: "Café/Bistro",
    fusion: "Fusion",
    international: "International",
    other: "Other",
  },
  menuCategory: {
    APPETIZER: "Appetizer",
    FIRST_COURSE: "First Course",
    SECOND_COURSE: "Second Course",
    SIDE_DISH: "Side Dish",
    SALAD: "Salad",
    PIZZA: "Pizza",
    SOUP: "Soup",
    DESSERT: "Dessert",
    FRUIT: "Fruit",
    CHEESE: "Cheese",
    BEVERAGE: "Beverage",
    WINE: "Wine",
    COCKTAIL: "Cocktail",
    COFFEE: "Coffee",
    KIDS_MENU: "Kids Menu",
    SPECIAL: "Special",
  },
  lang: {
    en: "English",
    it: "Italian",
    es: "Spanish",
    de: "German",
  },
} as const;
